if (!customElements.get('tab-content')) {
    customElements.define(
      'tab-content',
      class TabContent extends HTMLElement {
        constructor() {
            super();
            this.tabButtons = this.querySelectorAll('.tab-button')
            this.tabContents = this.querySelectorAll('.tab-content')
            this.bindEvents();
        }
  
        bindEvents() {
            this.tabButtons.forEach((button) =>
                button.addEventListener('click', this.onTabClick.bind(this))
            );
        }
  
        onTabClick(event) {
            event.preventDefault();

            let { buttonIndex } = event.currentTarget.dataset

            this.tabContents.forEach((el) => {
                let { sliderIndex } = el.dataset
                if (sliderIndex == buttonIndex) {
                    el.classList.add('is-active')
                } else {
                    el.classList.remove('is-active')
                }
            })

            this.tabButtons.forEach((el) => {
                if (el == event.currentTarget) {
                    el.classList.add('is-active')
                } else {
                    el.classList.remove('is-active')
                }
            })
        }
      }
    );
}